import {
  NullPointerException3mu0rhxjjitqq as NullPointerException,
  NoWhenBranchMatchedException3krrgsc7u48pz as NoWhenBranchMatchedException,
  ClassCastException1atiay3nqgbd as ClassCastException,
  UninitializedPropertyAccessException8qin22n38p0w as UninitializedPropertyAccessException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from './exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ensureNotNull(v) {
  var tmp;
  if (v == null) {
    THROW_NPE();
  } else {
    tmp = v;
  }
  return tmp;
}
function THROW_NPE() {
  throw NullPointerException().s4();
}
function noWhenBranchMatchedException() {
  throw NoWhenBranchMatchedException().w4();
}
function THROW_CCE() {
  throw ClassCastException().a5();
}
function throwUninitializedPropertyAccessException(name) {
  throw UninitializedPropertyAccessException().e5('lateinit property ' + name + ' has not been initialized');
}
function throwUnsupportedOperationException(message) {
  throw UnsupportedOperationException().i5(message);
}
//region block: exports
export {
  THROW_CCE as THROW_CCE2g6jy02ryeudk,
  ensureNotNull as ensureNotNull1e947j3ixpazm,
  noWhenBranchMatchedException as noWhenBranchMatchedException2a6r7ubxgky5j,
  throwUninitializedPropertyAccessException as throwUninitializedPropertyAccessExceptionyynx7gkm73wd,
  throwUnsupportedOperationException as throwUnsupportedOperationException1esr5y6wgmpks,
};
//endregion

//# sourceMappingURL=hacks.mjs.map
